// Common HSN (goods) & SAC (services) codes for construction / supply. GST % is indicative (post 22-Sep-2025) — verify before billing.
export const HSN_SAC = [
  // ---- SAC (Services) ----
  ["995411", "SAC", "Construction services of single dwelling / multi dwelling buildings", 18],
  ["995412", "SAC", "Construction of residential buildings (multi-storey)", 18],
  ["995413", "SAC", "Construction of industrial buildings", 18],
  ["995414", "SAC", "Construction of commercial buildings", 18],
  ["995415", "SAC", "Construction of other non-residential buildings (schools, hospitals)", 18],
  ["995421", "SAC", "General construction of highways, streets, roads, railways, airfield runways", 18],
  ["995422", "SAC", "Construction of bridges, elevated highways, tunnels", 18],
  ["995423", "SAC", "Construction of waterways, harbours, dams, water mains, irrigation", 18],
  ["995424", "SAC", "Construction of pipelines, communication & power lines (cables)", 18],
  ["995425", "SAC", "Construction of mines and industrial plants", 18],
  ["995426", "SAC", "Construction of sports & recreation facilities", 18],
  ["995429", "SAC", "Other civil engineering works (boundary wall, drains, culverts)", 18],
  ["995431", "SAC", "Demolition services", 18],
  ["995432", "SAC", "Site formation, clearing, excavation & earth moving", 18],
  ["995433", "SAC", "Site preparation for mining", 18],
  ["995434", "SAC", "Scaffolding services", 18],
  ["995435", "SAC", "Test drilling and boring", 18],
  ["995441", "SAC", "Pile driving / foundation services", 18],
  ["995442", "SAC", "Building framing & roof framing", 18],
  ["995443", "SAC", "Roofing and water proofing services", 18],
  ["995444", "SAC", "Concrete services (RCC, PCC, shuttering)", 18],
  ["995445", "SAC", "Structural steel erection services", 18],
  ["995446", "SAC", "Bricklaying / masonry services", 18],
  ["995447", "SAC", "Stone setting services", 18],
  ["995461", "SAC", "Electrical installation services (wiring, fittings)", 18],
  ["995462", "SAC", "Water plumbing and drain laying", 18],
  ["995463", "SAC", "Heating, ventilation & air conditioning (HVAC) installation", 18],
  ["995464", "SAC", "Gas fitting installation", 18],
  ["995465", "SAC", "Insulation services", 18],
  ["995466", "SAC", "Lift and escalator installation", 18],
  ["995468", "SAC", "Other installation services (fire fighting, CCTV)", 18],
  ["995471", "SAC", "Glazing services", 18],
  ["995472", "SAC", "Plastering services", 18],
  ["995473", "SAC", "Painting services", 18],
  ["995474", "SAC", "Floor and wall tiling services", 18],
  ["995475", "SAC", "Other floor laying, wall covering, wall papering", 18],
  ["995476", "SAC", "Joinery and carpentry services", 18],
  ["995477", "SAC", "Fencing and railing services", 18],
  ["995478", "SAC", "Other building completion & finishing", 18],
  ["995479", "SAC", "Renting of construction machinery with operator", 18],
  ["998311", "SAC", "Management consulting / project management services", 18],
  ["998321", "SAC", "Architectural services", 18],
  ["998331", "SAC", "Engineering services / design consultancy", 18],
  ["998346", "SAC", "Technical testing & analysis (material testing)", 18],
  ["998519", "SAC", "Manpower supply / labour supply services", 18],
  ["998533", "SAC", "Cleaning & housekeeping services", 18],
  ["998525", "SAC", "Security services", 18],
  ["996511", "SAC", "Road transport of goods (GTA)", 5],
  ["997319", "SAC", "Renting / leasing of machinery & equipment without operator", 18],
  ["998729", "SAC", "Maintenance & repair services of machinery", 18],
  // ---- HSN (Goods) ----
  ["2523", "HSN", "Cement (Portland, PPC, OPC, white cement)", 18],
  ["2505", "HSN", "Natural sand (river sand)", 5],
  ["2517", "HSN", "Stone aggregate, gravel, crushed stone, ballast, grit", 5],
  ["2515", "HSN", "Marble & travertine blocks", 5],
  ["2516", "HSN", "Granite blocks", 5],
  ["6802", "HSN", "Worked marble / granite / stone slabs & tiles", 18],
  ["6901", "HSN", "Bricks (fly ash / clay bricks)", 5],
  ["6904", "HSN", "Ceramic building bricks, blocks", 5],
  ["6810", "HSN", "Concrete blocks, paver blocks, precast articles, kerb stones", 18],
  ["6907", "HSN", "Ceramic / vitrified floor & wall tiles", 18],
  ["6910", "HSN", "Ceramic sinks, wash basins, WC, sanitary ware", 18],
  ["7213", "HSN", "TMT bars / steel rods (hot rolled)", 18],
  ["7214", "HSN", "Steel bars and rods (other)", 18],
  ["7216", "HSN", "Steel angles, channels, sections (MS structure)", 18],
  ["7306", "HSN", "Steel tubes & pipes (GI / MS pipes)", 18],
  ["7308", "HSN", "Steel structures, doors, windows, shutters, grills", 18],
  ["7217", "HSN", "Binding wire / steel wire", 18],
  ["7318", "HSN", "Bolts, nuts, screws, washers", 18],
  ["7210", "HSN", "GI / colour coated roofing sheets", 18],
  ["3208", "HSN", "Paints & varnishes (enamel, oil based)", 18],
  ["3209", "HSN", "Emulsion paints (water based)", 18],
  ["3214", "HSN", "Putty, wall putty, sealants", 18],
  ["3824", "HSN", "Construction chemicals, admixtures, waterproofing compounds", 18],
  ["2715", "HSN", "Bitumen / bituminous mixtures", 18],
  ["3917", "HSN", "PVC / CPVC / HDPE pipes and fittings", 18],
  ["3925", "HSN", "Plastic doors, windows, water tanks (builders' ware)", 18],
  ["4418", "HSN", "Wooden doors, windows, frames (builders' joinery)", 18],
  ["4412", "HSN", "Plywood, block board, veneered panels", 18],
  ["7005", "HSN", "Float glass / sheet glass", 18],
  ["8481", "HSN", "Taps, valves, cocks", 18],
  ["8544", "HSN", "Electric wires & cables", 18],
  ["8536", "HSN", "Switches, sockets, MCB, electrical fittings", 18],
  ["9405", "HSN", "Lights, LED fittings, lamps", 18],
  ["8413", "HSN", "Pumps (water / submersible)", 18],
  ["8414", "HSN", "Fans, exhaust fans", 18],
  ["8428", "HSN", "Lifts / elevators", 18],
  ["8474", "HSN", "Concrete mixer, crushing machinery", 18],
  ["2710", "HSN", "Diesel / lubricants (HSD, oil)", 18],
  ["6806", "HSN", "Insulation materials (glass wool, rock wool)", 18],
  ["6808", "HSN", "Gypsum boards, false ceiling panels", 18],
  ["2520", "HSN", "Gypsum / plaster of paris", 5],
  ["2522", "HSN", "Lime (quick lime, slaked lime)", 5],
  ["3816", "HSN", "Refractory cement, mortar", 18],
];

export const searchHsn = (q, limit = 10) => {
  const s = String(q || "").trim().toLowerCase();
  if (!s) return HSN_SAC.slice(0, limit);
  return HSN_SAC.filter(([code, , desc]) => code.startsWith(s) || desc.toLowerCase().includes(s)).slice(0, limit);
};
